import React, { useEffect, useRef } from "react";
import "./styles.css";
import { RootState } from "../../store";
import { connect } from "react-redux";
import { ReactComponent as CheckIcon } from "../../assets/icons/check.svg";
import { ReactComponent as Chevron } from "../../assets/icons/chevron.svg";
import { Button } from "../../components/common/Button";
import { Link } from "react-router-dom";
import {
  selectPaymentConfirmationUrl,
  selectPaymentError,
  selectPaymentErrorMessage,
  selectPaymentPending,
  selectPaymentSuccess,
  selectSubscriptionPlansError,
  selectSubscriptionPlansList,
  selectSubscriptionPlansPending,
  selectUserData,
} from "../../store/selectors";
import { UserActionCreator } from "../../store/userActions";
import { InfoBar } from "../../components/common/InfoBar";
import {
  ANALYTICS_EVENTS,
  trackAnalyticsEvent,
} from "../../analytics";

const _Payment = ({
                    pending,
                    error,
                    errorMessage,
                    success,
                    confirmationUrl,
                    userData,
                    paymentRequest,
                    subscriptionPlans,
                    subscriptionPlansPending,
                    subscriptionPlansError,
                    subscriptionPlansList,
                  }) => {
  const selectedPlanRef = useRef<any>(null);

  useEffect(() => {
    subscriptionPlans();
  }, []);

  useEffect(() => {
    if (success && confirmationUrl) {
      const plan = selectedPlanRef.current;
      trackAnalyticsEvent(ANALYTICS_EVENTS.PAYMENT_STARTED, {
        subscription_plan_id: plan?.id,
        subscription_plan_code: plan?.code,
        subscription_plan_amount: plan?.amount,
        subscription_plan_days: plan?.days,
      });
      window.location.href = confirmationUrl;
    }
  }, [confirmationUrl, success]);

  useEffect(() => {
    trackAnalyticsEvent(ANALYTICS_EVENTS.PAYMENT_OPENED, {
      payment_source: "payment_page",
    });
  }, []);

  if (!userData || subscriptionPlansPending) return null;

  const pay = (planId) => {
    const plan = subscriptionPlansList?.find((item) => item.id === planId);
    selectedPlanRef.current = plan || { id: planId };
    trackAnalyticsEvent(ANALYTICS_EVENTS.SUBSCRIPTION_PLAN_SELECTED, {
      subscription_plan_id: planId,
      subscription_plan_code: plan?.code,
      subscription_plan_amount: plan?.amount,
      subscription_plan_days: plan?.days,
      plan_permission_assignment_limit:
        plan?.settings?.userHasAssignmentDefaultLimit,
      plan_permission_assignment_expires:
        plan?.settings?.userHasAssignmentDefaultExpiresAt,
      plan_permission_assignment_private:
        plan?.settings?.userAllowAssignmentChangePrivate,
    });
    paymentRequest(planId);
  };

  return (
      <>
        <Link className="payment_back-link" to="/">
          <div className="payment_chevron">
            <Chevron width="16" height="16" fill="#000" />
          </div>
          назад
        </Link>
        <div className="payment_container">
          <h2>Тарификация</h2>

          {error && (
              <InfoBar
                  className="payment_error"
                  type="error"
                  text="Ошибка оплаты. Попробуйте ещё раз позже."
              />
          )}

          {subscriptionPlansError && (
              <InfoBar
                  className="payment_error"
                  type="error"
                  text="Ошибка загрузки тарифов"
              />
          )}

          <div className="payment_tariff-list">
            {subscriptionPlansPending && <div>Загрузка тарифов...</div>}

            {!subscriptionPlansPending &&
                subscriptionPlansList?.map((plan) => (
                    <div className="payment_tariff-container" key={plan.id}>
                      <div className="payment_tariff">
                        <div className="payment_tariff-title">
                          {plan.description}
                        </div>
                        <div className="payment_tariff-price">
                          {plan.amount} ₽
                        </div>
                        <div className="payment_tariff-description">
                          За {plan.days} дней
                        </div>
                        <ul className="payment_tariff-options">
                          {plan.settings?.userHasAssignmentDefaultLimit === false && (
                              <li>
                                <div className="payment_check-icon">
                                  <CheckIcon fill="#c06198" width="100%" height="100%" />
                                </div>
                                <div className="payment_tariff-option-text">
                                  Нет лимита на количество объектов
                                </div>
                              </li>
                          )}
                          {plan.settings?.userHasAssignmentDefaultExpiresAt === false && (
                              <li>
                                <div className="payment_check-icon">
                                  <CheckIcon fill="#c06198" width="100%" height="100%" />
                                </div>
                                <div className="payment_tariff-option-text">
                                  Объявления не скрываются автоматически
                                </div>
                              </li>
                          )}
                          {plan.settings?.userAllowAssignmentChangePrivate && (
                              <li>
                                <div className="payment_check-icon">
                                  <CheckIcon fill="#c06198" width="100%" height="100%" />
                                </div>
                                <div className="payment_tariff-option-text">
                                  Можно делать объявления приватными
                                </div>
                              </li>
                          )}
                        </ul>
                        <Button pending={pending} onClick={() => pay(plan.id)} text="выбрать" />
                      </div>
                    </div>
                ))}
          </div>
        </div>
      </>
  );
};

const mapStateToProps = (state: RootState) => ({
  pending: selectPaymentPending(state),
  error: selectPaymentError(state),
  errorMessage: selectPaymentErrorMessage(state),
  success: selectPaymentSuccess(state),
  confirmationUrl: selectPaymentConfirmationUrl(state),
  userData: selectUserData(state),
  subscriptionPlansPending: selectSubscriptionPlansPending(state),
  subscriptionPlansError: selectSubscriptionPlansError(state),
  subscriptionPlansList: selectSubscriptionPlansList(state),
});

const mapDispatchToProps = {
  subscriptionPlans: UserActionCreator.getSubscriptionPlans,
  paymentRequest: UserActionCreator.payment,
};

export const Payment = connect(mapStateToProps, mapDispatchToProps)(_Payment);
